export const EMPTY_ADDRESS = '0x0000000000000000000000000000000000000000'
export const MAX_INT_64 = BigInt('18446744073709551615')
export const MAX_DATE_INT = 8640000000000000
export const MINIMUM_DOT_ETH_CHARS = 3
export const GRACE_PERIOD_SECONDS = 7776000 // 90 days
